/* tslint:disable */
/* eslint-disable */
/**
 * Main API v1.0
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { IAggregateResult } from './IAggregateResult';
import {
    IAggregateResultFromJSON,
    IAggregateResultFromJSONTyped,
    IAggregateResultToJSON,
} from './IAggregateResult';
import type { PersonneHistoryGridDto } from './PersonneHistoryGridDto';
import {
    PersonneHistoryGridDtoFromJSON,
    PersonneHistoryGridDtoFromJSONTyped,
    PersonneHistoryGridDtoToJSON,
} from './PersonneHistoryGridDto';

/**
 * 
 * @export
 * @interface PersonneHistoryGridDtoPaginatedResults
 */
export interface PersonneHistoryGridDtoPaginatedResults {
    /**
     * 
     * @type {number}
     * @memberof PersonneHistoryGridDtoPaginatedResults
     */
    totalCount?: number;
    /**
     * 
     * @type {Array<PersonneHistoryGridDto>}
     * @memberof PersonneHistoryGridDtoPaginatedResults
     */
    results?: Array<PersonneHistoryGridDto> | null;
    /**
     * 
     * @type {Array<IAggregateResult>}
     * @memberof PersonneHistoryGridDtoPaginatedResults
     */
    aggregateResults?: Array<IAggregateResult> | null;
}

/**
 * Check if a given object implements the PersonneHistoryGridDtoPaginatedResults interface.
 */
export function instanceOfPersonneHistoryGridDtoPaginatedResults(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function PersonneHistoryGridDtoPaginatedResultsFromJSON(json: any): PersonneHistoryGridDtoPaginatedResults {
    return PersonneHistoryGridDtoPaginatedResultsFromJSONTyped(json, false);
}

export function PersonneHistoryGridDtoPaginatedResultsFromJSONTyped(json: any, ignoreDiscriminator: boolean): PersonneHistoryGridDtoPaginatedResults {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'totalCount': !exists(json, 'totalCount') ? undefined : json['totalCount'],
        'results': !exists(json, 'results') ? undefined : (json['results'] === null ? null : (json['results'] as Array<any>).map(PersonneHistoryGridDtoFromJSON)),
        'aggregateResults': !exists(json, 'aggregateResults') ? undefined : (json['aggregateResults'] === null ? null : (json['aggregateResults'] as Array<any>).map(IAggregateResultFromJSON)),
    };
}

export function PersonneHistoryGridDtoPaginatedResultsToJSON(value?: PersonneHistoryGridDtoPaginatedResults | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'totalCount': value.totalCount,
        'results': value.results === undefined ? undefined : (value.results === null ? null : (value.results as Array<any>).map(PersonneHistoryGridDtoToJSON)),
        'aggregateResults': value.aggregateResults === undefined ? undefined : (value.aggregateResults === null ? null : (value.aggregateResults as Array<any>).map(IAggregateResultToJSON)),
    };
}

